import { INTERNATIONAL_LOCALES } from "./locales"

interface LocalizedRouteMap {
  [englishPath: string]: {
    [locale: string]: string
  }
}

const englishPaths = [
  "/",
  "/catalog/",
  "/catalog/amazon-gift-cards/",
  "/demo/",
  "/demo/details/",
  "/demo/schedule/",
  "/demo/ty/",
  "/gift-card-api/",
  "/locale-demo-hardcoded-pricing/",
  "/pricing/",
  "/products/ach-payments/",
  "/products/bulk-payouts/",
  "/products/fraud-prevention/",
  "/products/gift-cards/",
  "/products/overview/",
  "/products/visa-cards/",
  "/solutions/employee-incentives/",
  "/solutions/marketing-incentives/",
  "/solutions/research-incentives/",
]

export const localizedRoutes: LocalizedRouteMap =
  englishPaths.reduce<LocalizedRouteMap>((acc, path) => {
    acc[path] = {}
    INTERNATIONAL_LOCALES.forEach(locale => {
      const localizedPath = `/${locale}${path === "/" ? "/" : path}`
      acc[path][locale] = localizedPath
    })
    return acc
  }, {})
